import React from 'react';
import Head from 'next/head';

import Footer from 'components/Footer';
import Header from 'components/Header';
import { Error } from 'components/SummitFlow/Error';

import { FC } from 'react';

const ErrorPage: FC = () => (
  <div className="page-wrapper">
    <Head>
      <meta name="description" content="CallAPro - Find a Home Service Professional Near You" />
      <title>Find Home Service Pros Near You</title>
    </Head>
    <Header />
    <Error />
    <Footer />
  </div>
);

export default ErrorPage;
